import shopifyDawnGenericDefaults from '../shopify-dawn-generic/config.js';

const InitFunc = () => {
  shopifyDawnGenericDefaults.InitFunc?.();

  if (!window.document.querySelector('product-info variant-selects')) {
    return;
  }

  let parked = null;

  // Combined Listing: park before Dawn replaces product-info / product-component.
  window.document.addEventListener(
    'change',
    (e) => {
      if (!e.target.closest('variant-selects')) {
        return;
      }

      const nextUrl = e.target.dataset?.productUrl;
      const currentUrl = window.document.querySelector('product-info')?.dataset?.url;
      if (!nextUrl || !currentUrl || nextUrl === currentUrl) {
        return;
      }

      const live = window.document.querySelector('product-component #cm-verify-fitment');
      if (!live) {
        return;
      }

      parked = live;
      window.document.body.appendChild(live);
    },
    true,
  );

  // After the new product-component mounts: put Verify back if the slot is empty.
  window.document.addEventListener('product-info:loaded', () => {
    window.setTimeout(() => {
      const slot = window.document.querySelector('product-component #cm-verify-fitment');
      if (!parked?.isConnected || !slot || slot === parked || slot.querySelector('.cm_vehicle-widget')) {
        return;
      }

      slot.replaceWith(parked);
      parked = null;

      const productInfo = window.document.querySelector('product-info');
      const { productId } = productInfo?.dataset || {};
      const { value: variantId } = productInfo?.querySelector('.product-variant-id') || {};
      if (productId && variantId) {
        window.Convermax.updateVerifyFitmentWidget(productId, variantId);
      }
    }, 300);
  });

  // Regular same-product variant change: Verify stays mounted — only refresh fitment.
  window.document.addEventListener('change', (e) => {
    if (!e.target.closest('variant-selects')) {
      return;
    }

    const nextUrl = e.target.dataset?.productUrl;
    const currentUrl = window.document.querySelector('product-info')?.dataset?.url;
    if (nextUrl && currentUrl && nextUrl !== currentUrl) {
      return;
    }

    window.setTimeout(() => {
      const productInfo = window.document.querySelector('product-info');
      if (!productInfo?.querySelector('#cm-verify-fitment')) {
        return;
      }

      const { productId } = productInfo.dataset;
      const { value: variantId } = productInfo.querySelector('.product-variant-id') || {};
      if (productId && variantId) {
        window.Convermax.updateVerifyFitmentWidget(productId, variantId);
      }
    }, 1000);
  });
};

export default {
  includes: ['shopify-dawn-generic'],
  ...shopifyDawnGenericDefaults,
  InitFunc,
};
